import { render, staticRenderFns } from "./review.vue?vue&type=template&id=f3228ce4&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=f3228ce4&prod&lang=stylus&scoped=true&"
import style1 from "./review.vue?vue&type=style&index=1&id=f3228ce4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3228ce4",
  null
  
)

export default component.exports